module.exports = __webpack_public_path__ + "img/icon-down.3ef0343b.svg";